import { number, object, SchemaOf, string } from 'yup'
import { CreateCartItemDTO } from '../dto/create_cart_item.dto'

export const createCartItemSchema: SchemaOf<CreateCartItemDTO> = object({
  itemKey: string().required('Товар не найден или не существует'),
  amount: number().required('Не указано количество'),
  reference: string().default(''), //.required('Референс не указан'),
})
